import React, { Component } from 'react';
import { connect } from 'react-redux'
import { fetchData, selectMainCategory } from './reducers/cartReducer'
import Navbar from './Navbar'
import startOrder from '../images/StartOrder_new.png'




class Start extends Component {
    constructor(props) {
        super(props)
        this.state = {
            status: "",
            daysOpen: [],
            showImage: true,
            message:"",
            jpTime : ""
        }
    }
    componentDidMount() {
        
        fetch('https://apps2.housing.k-state.edu/code/JPsatJardine/getInventory.php?revenueCenter=JPs')
            .then((response) => {
                return response.json();
            }).then(data => {
                this.setState({ status: data.active })
                this.setState({ daysOpen: data.daysOpen })
                this.setState({ message: data.Comment })
                this.setState({ jpTime: JSON.parse(data.time ) })

            });
        if (this.props.items.length == 0) {
            this.props.fetchData();
        }

    }

    handleClick = (mainCategory) => {

        if (mainCategory) {
            this.props.selectMainCategory(mainCategory);
            this.props.history.push("/home")

        }

    }
    handleAgree(value) {

        this.setState({ showImage: false });

    }


    render() {
        var flag = ''
        /////////////////////////
        var tempDate = new Date();
var currDate =  (tempDate.getMonth()+1)  + '/' +tempDate.getDate() + '/' + tempDate.getFullYear()

var hours =  tempDate.getHours();
var minutes= tempDate.getMinutes()
var seconds= tempDate.getSeconds()
var ampm = hours >= 12 ? 'PM' : 'AM';
hours = hours % 12;
hours = hours ? hours : 12;
 if (hours   < 10) {hours   = "0"+hours;}
 if (minutes < 10) {minutes = "0"+minutes;}
 if (seconds < 10) {seconds = "0"+seconds;}
 var currTime= hours+':'+minutes+' '+ ampm;
 var startTime = this.state.jpTime[0]
 var closeTime = Date.parse(currDate+" "+this.state.jpTime[1])



        ////////////////////////////
        if (this.props.location.state) {
            flag = this.props.location.state.flag
        } else {
            flag = false;
        }
        var tempDate = new Date();
        var day = tempDate.getDay();
        var centerOpen = false
        if (this.state.daysOpen.includes(day) && this.state.status == 1  && Date.parse(currDate+" "+currTime)<closeTime ) {
            centerOpen = true
        }
        let src = "/JPsatJardine/src/images/"
        let mainCategory = []
        if (this.props.items.length > 0) {
            this.props.items.forEach(element => {
                if (element.mainCategory != null && mainCategory.indexOf(element.mainCategory) == -1)
                    mainCategory.push(element.mainCategory)
            });
        }

        let Item1 = "../src/images/"

        return (
            <div>
                <Navbar isAuthed={true} />
                {centerOpen == true ?
                    <div className="container">
                        <br />
                        {this.state.showImage && !flag ? <a onClick={() => { this.handleAgree("showImage") }} >
                            <img class="responsive-img" src={startOrder} />
                            {/* <center><button class="waves-effect  btn purple darken-4" onClick={() => { this.handleAgree("showImage") }} >Click here</button> </center> */}
                            </a> : ""}

                        {!this.state.showImage || flag ? <div>
                            <h5 className="center menuselect">Select the menu</h5>
                            <div className="mainmenu box">
                                {this.props.items.length > 0 ?
                                    mainCategory.map((item) =>
                                        <div className="main card" key={item} onClick={() => { this.handleClick(item) }}>

                                            <div className="card-image">

                                                <img src={Item1 + item + ".jpg"} onError={(e) => { e.target.onerror = null; e.target.src = "" }} />

                                                {/* <button class="wwaves-effect waves-light btn red" to="/"  onClick={()=>{this.handleClick(item)}}>Order </button>  
                                              */}
                                                {/* <button class="" to="/"  onClick={()=>{this.handleClick(item)}}>Order Now</button> */}
                                                <span class="mainName" ><b>{" " + item}</b></span>
                                            </div>


                                        </div>
                                    ) : ""
                                }
                            </div>

                        </div> : ""}

                    </div> : <div className="container"><br /><div class="materialert danger ">
                        <div class="material-icons">error_outline</div>
                        {this.state.message}
		</div></div>}
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {

        items: state.items,
        orders: state.orders
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => { dispatch(fetchData()) },
        selectMainCategory: (id) => { dispatch(selectMainCategory(id)) },

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Start)